(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('validateUrl', ValidateUrl);

    function ValidateUrl() {

        function verifyUrl(str) {
            const urlPattern = new RegExp('^((ft|htt)ps?:\\/\\/)?' + // Protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // Domain name and extension
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // Or ip (v4) address
                '(\\:\\d+)?' + // Port
                '(\\/[-a-z\\d%@_.~+&:]*)*' + // Path
                '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // Query string
                '(\\#[-a-z\\d_]*)?$', 'i');

            return urlPattern.test(str);
        }

        function link(scope, elem, attrs, ctrl) {

            scope.$watch(attrs.ngModel, function (value) {

                if (verifyUrl(value))
                    ctrl.$setValidity('url', true);
                else
                    ctrl.$setValidity('url', false);

            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());